<div class="wrapper">

  <div class="block-center mt-4 wd-xl">

    <div class="card card-flat">

      <div class="card-header text-center bg-primary">
        <a href="#">
          <p>Dash</p>
        </a>
      </div>

      <!-- VALIDAÇÃO DE CPF -->
      @if (fase == 'check') {
        <div class="card-body">
          <p class="text-center text-muted mb-4">Insira seu CPF para<br/>resgate de nova senha.</p>
          <div class="input-group mb-3">
            <input class="form-control"
              type="text" placeholder="CPF"
              [(ngModel)]="formResgate.cpf" [ngModelOptions]="{standalone: true}"/>
            <span class="input-group-text bg-transparent">
              <em class="fa fa-user text-muted"></em>
            </span>
          </div>
          @if (errorMessage != '') {
            <div class="alert alert-danger" role="alert">
              {{errorMessage}}
            </div>
          }
          <div class="d-grid gap-2 mb-3">
            <button class="btn btn-primary btn-lg" (click)="resgatarSenha()">ENVIAR</button>
          </div>
          <div class="d-grid">
            <button class="btn btn-outline-secondary" (click)="goLogin()">VOLTAR</button>
          </div>
        </div>
      }

      <!-- CONFIRMAÇÃO DE CADASTRO -->
      @if (fase == 'sucesso') {
        <div class="card-body text-center">
          <div class="mb-4">
            <div class="text-success mb-3">
              <i class="fa fa-check-circle fa-3x"></i>
            </div>
            <h4 class="text-success mb-3">RESGATE REALIZADO<br/>COM SUCESSO</h4>
            <p class="text-muted">Sua senha foi enviada para o celular <strong>{{celular}}</strong>.</p>
          </div>
          <div class="d-grid">
            <button class="btn btn-primary btn-lg" (click)="goLogin()">
              ACESSAR SISTEMA
            </button>
          </div>
        </div>
      }

    </div>

  </div>

</div>
